import { InputAdornment, TextField } from '@mui/material';
import { validDecimal } from 'app/helpers/numberHelper';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectIsEditMod } from 'store/redux-store/placement-mods/selectors';

export const TotalAmountFee = () => {
  const { control, getValues, setValue, clearErrors, setError } = useFormContext();
  const { t } = useTranslation();
  const totalAdminFee = 'totalAdminFee';
  const isModEdit = useSelector(selectIsEditMod);

  const validation = name => {
    if (getValues(name)) {
      clearErrors(name);
    } else {
      setError(name, {});
    }
  };

  const handleChange = (value: string) => {
    if (!(parseFloat(value) > 0)) {
      setValue('feeStartDate', '');
      setValue('perCheckAdminFee', '');
      clearErrors('feeStartDate');
      clearErrors('perCheckAdminFee');
    } else {
      validation('perCheckAdminFee');
      validation('feeStartDate');
    }
  };

  return (
    <Controller
      control={control}
      name={totalAdminFee}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          variant="filled"
          fullWidth
          color="primary"
          autoComplete="off"
          label={t('placement.placementMods.totalAdminFee')}
          InputProps={{
            readOnly: !isModEdit,
            style: {
              pointerEvents: !isModEdit ? 'none' : 'auto',
            },
            startAdornment: (
              <>
                {getValues(totalAdminFee) && <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>}
              </>
            ),
          }}
          value={getValues(totalAdminFee) ?? ''}
          required={false}
          onChange={e => {
            const inputValue = e.target.value;
            if (validDecimal(inputValue, { numberLength: 6, decimalLength: 2 })) {
              const validInput = inputValue.replace(/^\./, '0.');
              setValue(totalAdminFee, validInput, { shouldDirty: true });
              handleChange(validInput);
            }
          }}
        />
      )}
    />
  );
};
